import type { SubscribersAnalysisData } from '@/modules/tracking/new-subscriber-analysis/types.ts'
import { apiClient } from '@/utils/axios.ts'
import { dateToString } from '@/utils/helpers.ts'

export const createHighSpenderList = async (
  name: string,
  creatorId: number,
  from: Date,
  to: Date,
  spendLimit: number,
): Promise<SubscribersAnalysisData> => {
  const params = {
    from: dateToString(from),
    to: dateToString(to),
    spendLimit,
  }
  const response = await apiClient.post(
    `/lists/${creatorId}/new-subscriber/high-spender-list`,
    { name },
    {
      params,
    },
  )

  return response.data
}
